import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import BrandIntro from './components/BrandIntro';
import CTASection from './components/CTASection';
import Testimonials from './components/Testimonials';

export default function Home() {
  useEffect(() => {
    document.title = '51吃瓜网入口 - 官网入口与最新地址 | 网红黑料吃瓜爆料视频';
  }, []);

  return (
    <>
      <main>
        <Navbar />
        <HeroSection />
        <FeatureGrid />
        <BrandIntro />
        <CTASection />
        <Testimonials />
      </main>
      <Footer />
    </>
  );
}